import { handleActions } from "redux-actions";
import { initTrackerModuleLoading } from "modules/Tracker/services/initialization/actions";
import {
    setTrackerProgressInfo,
    setEditMessageDialog,
    mergeEditMessageDialog,
    setSelectedTrackerTasks,
    getTracks,
    getTracksSuccess,
    getTracksError,
    clearTracks,
    setLoadersOnTasks,
    getCountTracks,
    getCountTracksSuccess,
    getCountTracksError,
    setBackDropLoader,
    setTrackFullMessage
} from "modules/Tracker/services/Tracks/actions";

const initialState = {
    isLoading: false,
    isBackDropLoader: false,
    isLoadingTrackerModule: false,
    isLoadingCount: false,
    count: 0,
    ids: [],
    scrapeTasks: {},
    progressInfo: {},
    fullMessages: {},
    selectedTasks: [],
    loadersOnTasks: [],
    editMessageDialog: {
        isOpen: false,
        mustNotHaveMessages: null,
        fieldValue: null,
        message: ""
    }
};

export const tracksEntriesReducer = handleActions(
    {
        [setBackDropLoader]: (state, { payload }) => ({
            ...state,
            isBackDropLoader: payload
        }),
        [initTrackerModuleLoading]: (state, { payload }) => ({
            ...state,
            isLoadingTrackerModule: payload
        }),
        [clearTracks]: () => ({ ...initialState }),
        [getTracks]: (state) => ({
            ...state,
            count: 0,
            ids: [],
            scrapeTasks: {},
            selectedTasks: [],
            isLoading: true
        }),
        [getTracksSuccess]: (state, { payload }) => ({
            ...state,
            ...payload
        }),
        [getTracksError]: (state) => ({
            ...state,
            isLoading: false
        }),

        [getCountTracks]: (state) => ({
            ...state,
            isLoadingCount: true
        }),
        [getCountTracksSuccess]: (state, { payload }) => ({
            ...state,
            count: payload,
            isLoadingCount: false
        }),
        [getCountTracksError]: (state) => ({
            ...state,
            isLoadingCount: false
        }),

        [setLoadersOnTasks]: (state, { payload }) => {
            let newLoadersList = [ ...state.loadersOnTasks ];

            if (newLoadersList.some((item) => item === payload)) {
                newLoadersList = newLoadersList.filter((item) => item !== payload);
            } else {
                newLoadersList.push(payload);
            }

            return {
                ...state,
                loadersOnTasks: newLoadersList
            };
        },

        [setSelectedTrackerTasks]: (state, { payload }) => ({
            ...state,
            selectedTasks: payload
        }),

        [setTrackerProgressInfo]: (state, { payload }) => ({
            ...state,
            progressInfo: {
                ...state.progressInfo,
                ...payload
            }
        }),

        [setTrackFullMessage]: (state, { payload }) => ({
            ...state,
            fullMessages: {
                ...state.fullMessages,
                ...payload
            }
        }),

        [setEditMessageDialog]: (state, { payload }) => ({
            ...state,
            editMessageDialog: {
                ...initialState.editMessageDialog,
                ...payload
            }
        }),
        [mergeEditMessageDialog]: (state, { payload }) => ({
            ...state,
            editMessageDialog: {
                ...state.editMessageDialog,
                ...payload
            }
        })
    },
    initialState
);
